import { z } from "zod";

import { OfferProductDtoSchema } from "../../../../../dtos/offer-products";

export const PluginOfferProductSchema_2024_05_05 = OfferProductDtoSchema;

export type PluginOfferProductType_2024_05_05 = z.infer<
  typeof PluginOfferProductSchema_2024_05_05
>;
